<mat-progress-spinner *ngIf="isLoading" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="teeth-probing-loading-spinner"></mat-progress-spinner>
<div class='probe-depth-main' data-cy="teeth-probing-container">
  <mat-grid-list *ngIf="!isLoading" cols="6" rowHeight="100%" style="height:100%;" data-cy="teeth-probing-grid">
    <mat-grid-tile colspan="2" data-cy="teeth-probing-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="teeth-probing-list-card">
        <span class="configuration-section-title" data-cy="teeth-probing-list-title">Probing Depth</span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="teeth-probing-list-content">
          <tdo-table sortActive="ToothId" sortDirection="asc" [isAutoSelectFirstItem]="true" (rowSelected)="onRowSelected($event)" #toothTable [dataSource]="cfgTeeth" [isSearchable]="false" data-cy="teeth-probing-table">
            <tdo-table-column displayName="Tooth #" propertyName="ToothId" [rowTemplate]="tooth" data-cy="teeth-probing-tooth-column">
              <ng-template #tooth let-row>
                <div data-cy="teeth-probing-tooth-{{getToothNum(row.ToothId)}}">{{getToothNum(row.ToothId)}}</div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="!isLoading" colspan="4" data-cy="teeth-probing-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="teeth-probing-detail-card">
        <mat-card-content data-cy="teeth-probing-detail-content">
          <div style="max-width: 700px;" data-cy="teeth-probing-detail-container">
            <span class="configuration-section-title" data-cy="teeth-probing-detail-title">Probing Depth Autofill Info</span>
            <app-tdo-configuration-action-bar
              [showEdit]="false"
              [saveDisabled]="false"
              [showSave]="true"
              [showCancel]="false"
              [newHidden]="false"
              [showAdd]="false"
              (newClick)="onNew($event)"
              (saveClick)="onSave()"
              data-cy="teeth-probing-action-bar">
            </app-tdo-configuration-action-bar>
            <div *ngIf="selectedTooth" style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="teeth-probing-surface-container">
              <tdo-table [isAutoSelectFirstItem]="true" #autofillTable [dataSource]="selectedTooth?.cfgToothSurfaces" [isSearchable]="false" data-cy="teeth-probing-surface-table">
                <tdo-table-column displayName="Surface" propertyName="enumToothSurfaceID" [rowTemplate]="canal" data-cy="teeth-probing-surface-column">
                  <ng-template #canal let-row>
                    <div data-cy="teeth-probing-surface-name-{{getSurfaceName(row.enumToothSurfaceID)}}">{{getSurfaceName(row.enumToothSurfaceID)}}</div>
                  </ng-template>
                </tdo-table-column>
                <tdo-table-column displayName="Probing Depth" propertyName="xauditDeleted" [rowTemplate]="pd" data-cy="teeth-probing-depth-column">
                  <ng-template #pd let-row>
                    <tdo-dropdown-v2 
                      [value]="getProbingValue(row.model)" 
                      (selectionChange)="onProbeSelectionChange($event, row.model)" 
                      [datasource]="probingEnums" 
                      displayProperty="ItemDisplayValue"
                      data-cy="teeth-probing-depth-dropdown-{{getSurfaceName(row.model.enumToothSurfaceID)}}"></tdo-dropdown-v2>
                  </ng-template>
                </tdo-table-column>
              </tdo-table>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
